import { streamGeneration } from "@/hooks/generate/streamGeneration";
import type { Editor } from "@tiptap/react";

export async function handleFloatingAction(
  action:
    | "webSearch"
    | "docSearch"
    | "outline"
    | "idea"
    | "intro"
    | "customPrompt",
  prompt: string,
  editor: Editor
) {
  const loadingText = "⏳ 생성중...";
  let startPos: number | null = null;

  try {
    // 에디터 포커스 및 현재 위치 확인
    editor.commands.focus();

    startPos = editor.state.selection.from;

    // 로딩 텍스트 삽입
    editor.commands.insertContent(loadingText);

    switch (action) {
      case "customPrompt":
        // streamGeneration에서 모든 처리 (로딩 제거 포함)를 담당
        await streamGeneration(
          "customPrompt",
          prompt,
          editor,
          undefined,
          startPos,
          loadingText
        );
        startPos = null; // 성공적으로 완료되면 null로 설정
        break;

      default:
        // 다른 액션들은 즉시 로딩 텍스트 제거
        if (startPos !== null) {
          const endPos = startPos + loadingText.length;
          editor.commands.deleteRange({ from: startPos, to: endPos });
          editor.commands.insertContent(`✅ ${action} 완료`);
          startPos = null;
        }
    }
  } catch (error) {
    console.error("Error in handleFloatingAction:", error);

    // 에러 발생 시 로딩 텍스트 제거하고 에러 메시지 표시
    if (startPos !== null) {
      const endPos = startPos + loadingText.length;
      editor.commands.deleteRange({ from: startPos, to: endPos });
      editor.commands.insertContent("❌ 생성 중 오류가 발생했습니다.");
    }
  } finally {
    console.log("=== handleFloatingAction 완료 ===");
  }
}
